import React from "react";

import { UserDialogForm } from "../../pages/infrastructure/user/form";
import { PageDialogForm } from "../../pages/infrastructure/page/form";
import { MerchantDialogForm } from "../../pages/infrastructure/merchant/form";

export enum OfficeDialogKeys {
  USERS = "users",
  MERCHANTS = "merchants",

  PAGES_CREATE = "pagesCreate",
  PAGES_EDIT = "pagesEdit",
}

export const officeGlobalDialogComponentsSchema = {
  [OfficeDialogKeys.USERS]: UserDialogForm,
  [OfficeDialogKeys.MERCHANTS]: MerchantDialogForm,

  [OfficeDialogKeys.PAGES_CREATE]: PageDialogForm,
  [OfficeDialogKeys.PAGES_EDIT]: PageDialogForm,
} as const satisfies Record<OfficeDialogKeys, React.ComponentType<any>>;
